// extracted by mini-css-extract-plugin
export default {"uploadDocumentSection":"UploadForm_uploadDocumentSection__29vRp","uploadText":"UploadForm_uploadText__evNXf"};